import { Befehl } from '../models'
import { hasFieldContent, hasFieldOrBothFields } from './helpers'

/**
 * Checks if Befehl 95 has empty fields.
 *
 * Conditions:
 * - 95.50: requires either km (95.51) OR (signal + zugmeldestelle) (95.52)
 * - 95.95: requires freitext content (95.96)
 * - Other aufträge (95.10, 95.20, 95.30, 95.40) have no content fields
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl95EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // Check if ANY required field is empty
  for (const auftrag of befehl.auftraege) {
    // Check Auftrag 95.50 - requires either km OR (signal + zugmeldestelle)
    if (auftrag.kennung === '95.50') {
      const hasContent = hasFieldOrBothFields(
        auftrag,
        '95.51',
        'km',
        '95.52',
        'signal',
        '95.52',
        'zugmeldestelle.name'
      )
      if (!hasContent) return true
    }

    // Check Auftrag 95.95 - requires freitext content
    if (auftrag.kennung === '95.95') {
      if (!hasFieldContent(auftrag, '95.96', 'freitext')) {
        return true
      }
    }
  }

  // Aufträge without content fields (95.10, 95.20, 95.30, 95.40, 95.53, 95.54)
  // are always considered valid and don't need checking
  return false
}
